import { SelectItem } from "../types/locationTypes"

const createBreakDurations = (): SelectItem[] => [
    {
        text: 'None',
        value: '',
        selected: false,
        disabled: false,
    },
    {
        text: '15 mins',
        value: '15',
        selected: false,
        disabled: false,
    },
    {
        text: '30 mins',
        value: '30',
        selected: false,
        disabled: false,
    },
    {
        text: '45 mins',
        value: '45',
        selected: false,
        disabled: false,
    }
]

const createMaxBreakDelays = (): SelectItem[]  => [
    {
        text: 'None',
        value: '',
        selected: false,
        disabled: false,
    },
    {
        text: '1 hour',
        value: '1',
        selected: false,
        disabled: false,
    },
    {
        text: '2 hours',
        value: '2',
        selected: false,
        disabled: false,
    },
]

const parseIntOrNull = (value: any) => isNaN(parseInt(value))? null: parseInt(value);

export {
    createBreakDurations,
    createMaxBreakDelays,
    parseIntOrNull
}